/* eslint-disable import/prefer-default-export */
export const QUERIES = {
  ASYNC_SELECT: '@queries_async_select',
  FORMS: {
    LIST: '@QUERIES_FORMS_LIST',
    LIST_LABELS: '@QUERIES_FORMS_LIST_LABELS',
    LIST_WITH_DOCUMENTS: '@QUERIES_FORMS_LIST_WITH_DOCUMENTS',
    GET: '@QUERIES_FORMS_GET',
    ADD: '@QUERIES_FORMS_ADD',
    UPDATE: '@QUERIES_FORMS_UPDATE',
    DELETE: '@QUERIES_FORMS_DELETE',
    ANALYTICS: {
      LIST: '@QUERIES_FORMS_ANALYTICS_LIST',
      LIST_ABANDONMENT: '@QUERIES_FORMS_ANALYTICS_LIST_ABANDONMENT',
    },
    LOAD_TO_SELECT: '@QUERIES_FORMS_LOAD_TO_SELECT',
  },
  QUESTIONS: {
    LIST: '@QUERIES_QUESTIONS_LIST',
    LOAD: '@QUERIES_QUESTIONS_LOAD',
    COMPLETE_PAGE_CONDITIONAL_RULE:
      '@QUERIES_QUESTIONS_COMPLETE_PAGE_CONDITIONAL_RULE',
  },
  PACKETS: {
    LIST: '@QUERIES_PACKETS_LIST',
    GET: '@QUERIES_PACKETS_GET',
    ADD: '@QUERIES_PACKETS_ADD',
    UPDATE: '@QUERIES_PACKETS_ADD',
    DELETE: '@QUERIES_PACKETS_DELETE',
    LOAD_TO_SELECT: '@QUERIES_PACKETS_LOAD_TO_SELECT',
  },
  CUSTOMERS: {
    LOAD_TO_SELECT: 'QUERIES_CUSTOMERS_LOAD_TO_SELECT',
    LIST: '@QUERIES_CUSTOMERS_LIST',
    GET: '@QUERIES_CUSTOMERS_GET',
    UPDATE: '@QUERIES_CUSTOMERS_UPDATE',
    TAGS: {
      LIST: '@QUERIES_CUSTOMERS_TAGS_LIST',
    },
  },
  CUSTOMER_FIELDS: {
    LIST: '@QUERIES_CUSTOMER_FIELDS_LIST',
    TYPES: '@QUERIES_CUSTOMER_FIELDS_TYPES',
    ADD: '@QUERIES_CUSTOMER_FIELDS_ADD',
    UPDATE: '@QUERIES_CUSTOMER_FIELDS_UPDATE',
    DELETE: '@QUERIES_CUSTOMER_FIELDS_DELETE',
  },
  MEASURES: {
    LIST: '@QUERIES_MEASURES_LIST',
    LOAD_BY_FORM_AND_CLIENT_ID: '@QUERIES_MEASURES_LOAD_BY_FORM_AND_CLIENT_ID',
  },
  REPORTS: {
    LIST: '@QUERIES_REPORTS_LIST',
  },
  RESOURCES_SETTINGS: '@QUERIES_RESOURCES_SETTINGS',
  PREVIEW_FORM: '@QUERIES_PREVIEW_FORM',
  ROUTINES: {
    LIST: '@QUERIES_ROUTINES_LIST',
    ADD: '@QUERIES_ROUTINES_ADD',
    UPDATE: '@QUERIES_ROUTINES_UPDATE',
    DELETE: '@QUERIES_ROUTINES_DELETE',
  },
  VERSION: {
    GET: '@QUERIES_VERSION_GET',
  },
  EXPORTS: {
    LIST: '@QUERIES_EXPORTS_LIST',
    GET: '@QUERIES_EXPORTS_GET',
    GET_ANSWERS: '@QUERIES_EXPORTS_GET_ANSWERS',
    GET_RESPONSES: '@QUERIES_EXPORTS_GET_RESPONSES',
    ADD: '@QUERIES_EXPORTS_ADD',
    UPDATE: '@QUERIES_EXPORTS_UPDATE',
    DELETE: '@QUERIES_EXPORTS_DELETE',
    DOWNLOAD: '@QUERIES_EXPORTS_DOWNLOAD',
  },
  EXPORT_FILES: {
    LIST: '@QUERIES_EXPORTS_LIST',
    GET: '@QUERIES_EXPORTS_GET',
    ADD: '@QUERIES_EXPORTS_ADD',
    DELETE: '@QUERIES_EXPORTS_DELETE',
    DOWNLOAD: '@QUERIES_EXPORTS_DOWNLOAD',
  },
  GOOGLE_DRIVE_SETTINGS: {
    LIST: '@QUERIES_GOOGLE_DRIVE_SETTINGS_LIST',
    GET: '@QUERIES_GOOGLE_DRIVE_SETTINGS_GET',
    ADD: '@QUERIES_GOOGLE_DRIVE_SETTINGS_ADD',
    UPDATE: '@QUERIES_GOOGLE_DRIVE_SETTINGS_UPDATE',
    DELETE: '@QUERIES_GOOGLE_DRIVE_SETTINGS_DELETE',
  },
  GOOGLE_SHEETS_SETTINGS: {
    LIST: '@QUERIES_GOOGLE_SHEETS_SETTINGS_LIST',
    GET: '@QUERIES_GOOGLE_SHEETS_SETTINGS_GET',
    ADD: '@QUERIES_GOOGLE_SHEETS_SETTINGS_ADD',
    UPDATE: '@QUERIES_GOOGLE_SHEETS_SETTINGS_UPDATE',
    DELETE: '@QUERIES_GOOGLE_SHEETS_SETTINGS_DELETE',
  },
  TEMPLATES: {
    LIST: '@QUERIES_TEMPLATES_LIST',
  },
  REMINDERS: {
    LOAD_BY_ID: '@QUERIES_REMINDERS_LOAD_BY_ID',
    LIST: '@QUERIES_REMINDERS_LIST',
    GET_GLOBAL: '@QUERIES_REMINDERS_GET_GLOBAL',
    ADD: '@QUERIES_REMINDERS_ADD',
    UPDATE: '@QUERIES_REMINDERS_UPDATE',
    DELETE: '@QUERIES_REMINDERS_DELETE',
  },
  BUSINESS_ASSOCIATE_AGREEMENT: {
    GET: '@QUERIES_BUSINESS_ASSOCIATE_AGREEMENT_GET',
  },
  PROFILE: {
    ROLES: {
      LOAD: '@QUERIES_PROFILE_ROLES_LOAD',
      ADD_NEW: '@QUERIES_PROFILE_ROLES_ADD_NEW',
      UPDATE_BY_ID: '@QUERIES_PROFILE_ROLES_UPDATE_BY_ID',
      DELETE_BY_ID: '@QUERIES_PROFILE_ROLES_DELETE_BY_ID',
    },
  },
  RESPONSES: {
    LIST: '@QUERIES_RESPONSES_LIST',
    GET: '@QUERIES_RESPONSES_GET',
    GET_PUBLIC: '@QUERIES_RESPONSES_GET_PUBLIC',
    ADD: '@QUERIES_RESPONSES_ADD',
    UPDATE: '@QUERIES_RESPONSES_UPDATE',
    DELETE: '@QUERIES_RESPONSES_DELETE',
  },
  USERS: {
    LIST: '@QUERIES_USERS_LIST',
    LIST_LABELS: '@QUERIES_USERS_LIST_LABELS',
    DETAILS: '@QUERIES_USERS_DETAILS',
    UPDATE_DETAILS: '@QUERIES_USERS_UPDATE_DETAILS',
    MFA: {
      ENABLE: '@QUERIES_USERS_MFA_ENABLE',
      DISABLE: '@QUERIES_USERS_MFA_DISABLE',
      SETUP: '@QUERIES_USERS_MFA_SETUP',
      VERIFY: '@QUERIES_USERS_MFA_VERIFY',
    },
  },
  RESPONSE_QUEUE: {
    LIST: '@QUERIES_RESPONSE_QUEUE_LIST',
    UPDATE: '@QUERIES_RESPONSE_QUEUE_UPDATE',
  },
  PDF_DOCUMENTS: {
    LIST: '@QUERIES_DOCUMENTS_LIST',
    GET: '@QUERIES_DOCUMENTS_GET',
    ADD: '@QUERIES_DOCUMENTS_ADD',
    UPDATE: '@QUERIES_DOCUMENTS_UPDATE',
    DELETE: '@QUERIES_DOCUMENTS_DELETE',
  },
  PAYMENTS: {
    GET_BILLING: '@QUERIES_BILLING_GET',
    GET_PLANS: '@QUERIES_PLANS_GET',
    GET_PRODUCTS: '@QUERIES_PRODUCTS_GET',
    UPDATE_BILLING_DETAILS: '@QUERIES_BILLING_UPDATE',
    GET_STRIPE_CUSTOMER: '@QUERIES_STRIPE_CUSTOMER_GET',
    UPDATE_STRIPE_CUSTOMER: '@QUERIES_STRIPE_CUSTOMER_UPDATE',
  },
  ASSIGNED_RESPONSES: {
    ADD: '@QUERIES_ASSIGNED_RESPONSES_ADD',
    UPDATE: '@QUERIES_ASSIGNED_RESPONSES_UPDATE',
    DELETE: '@QUERIES_ASSIGNED_RESPONSES_DELETE',
  },
  AUTOMATIONS: {
    WORKFLOWS: {
      LIST: '@QUERIES_AUTOMATIONS_WORKFLOWS_LIST',
      GET: '@QUERIES_AUTOMATIONS_WORKFLOWS_GET',
      ADD: '@QUERIES_AUTOMATIONS_WORKFLOWS_ADD',
      UPDATE: '@QUERIES_AUTOMATIONS_WORKFLOWS_UPDATE',
      DELETE: '@QUERIES_AUTOMATIONS_WORKFLOWS_DELETE',
    },
    APPOINTMENT_TYPES: {
      LIST: '@QUERIES_AUTOMATIONS_APPOINTMENT_TYPES_LIST',
      SYNC: '@QUERIES_AUTOMATIONS_APPOINTMENT_TYPES_SYNC',
    },
  },
  INTEGRATIONS: {
    STRIPE: {
      GET: '@QUERIES_INTEGRATIONS_STRIPE_GET',
      ADD: '@QUERIES_INTEGRATIONS_STRIPE_ADD',
      UPDATE: '@QUERIES_INTEGRATIONS_STRIPE_UPDATE',
      DELETE: '@QUERIES_INTEGRATIONS_STRIPE_DELETE',
      CUSTOMER: {
        ADD: '@QUERIES_INTEGRATIONS_STRIPE_CUSTOMER_ADD',
      },
    },
    DEMOGRAPHICS: {
      GET: '@QUERIES_INTEGRATIONS_DEMOGRAPHICS_GET',
    },
  },
  TEAM: {
    UPDATE: '@QUERIES_TEAM_UPDATE',
  },
  ANSWERS: {
    ANSWER_SIGNATURE: {
      SAVE: '@QUERIES_ANSWERS_ANSWER_SIGNATURE_SAVE',
      DELETE: '@QUERIES_ANSWERS_ANSWER_SIGNATURE_DELETE',
    },
  },
  MESSAGES: {
    CREATE: '@QUERIES_MESSAGES_CREATE',
  },
}
